import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { formatSgd } from '../../lib/pricing';
import { DRAFT_KEY } from './HomePage';
import './marketing.css';

const APOLOGY = 'Apologies for the inconvenience. For now, we can only accept Singapore PayNow QR payments as we work towards supporting other payment methods. Thank you for your understanding.';

export default function PaymentPage() {
  const navigate = useNavigate();
  const [draft, setDraft] = useState(null);
  const [qrUrl, setQrUrl] = useState('');
  const [showApology, setShowApology] = useState(false);
  const [qrKind, setQrKind] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const raw = sessionStorage.getItem(DRAFT_KEY);
    if (!raw) {
      navigate('/', { replace: true });
      return;
    }
    const parsed = JSON.parse(raw);
    setDraft(parsed);
    const params = new URLSearchParams({
      country: parsed.customer_country || '',
      days: String(parsed.days || ''),
    });
    fetch(`/api/public-catalog?${params}`)
      .then((res) => res.json())
      .then((data) => {
        setQrUrl(data.paymentQrUrl || '');
        setShowApology(Boolean(data.showPaynowApology));
        setQrKind(data.qrKind || '');
      })
      .catch(() => setQrUrl(''));
  }, [navigate]);

  const handleNext = async () => {
    if (!draft) return;
    setSubmitting(true);
    setError('');
    try {
      const res = await fetch('/api/public-order', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...draft, tos_accepted: true }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || 'Could not submit your request');
      sessionStorage.removeItem(DRAFT_KEY);
      navigate('/thank-you', { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  if (!draft) return null;

  return (
    <div className="mkt-pay">
      <div className="mkt-pay-card">
        <h1>Pay with Paynow</h1>
        <p>
          {draft.canvas_label || 'Your canvas'} · {draft.days} day{draft.days === 1 ? '' : 's'} · {formatSgd(draft.fee)}
        </p>
        {showApology && <p className="mkt-pay-apology">{APOLOGY}</p>}
        {qrUrl ? (
          <img src={qrUrl} alt="Payment QR code" />
        ) : (
          <p>The payment QR has not been published yet. Please contact The Canvas Memories Team.</p>
        )}
        <p>
          {qrKind === 'generic'
            ? 'Scan the QR with your banking app and enter the amount shown above. Click Next after you have made payment.'
            : 'Scan the QR with your banking app to pay in SGD. Click Next after you have made payment.'}
        </p>
        {error && <div className="mkt-alert">{error}</div>}
        <button className="mkt-btn gold" type="button" onClick={handleNext} disabled={submitting}>
          {submitting ? 'Sending…' : 'Next'}
        </button>
      </div>
    </div>
  );
}
